import { render, staticRenderFns } from "./RejectRegistration.vue?vue&type=template&id=c803e57e&"
import script from "./RejectRegistration.vue?vue&type=script&lang=js&"
export * from "./RejectRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports